<template>
  <div>
    <div id="auditTop" class="main-page-content">
      <PageHeaderLayout :isBack="!$route.meta.hideBack">
          <el-tabs v-model="activeTab" type="card" @tab-click="handleTabClick">
            <el-tab-pane label="任务交付审核" name="task">
              <PrivatePersonnelListContent ref="taskContent" />
            </el-tab-pane>
            <el-tab-pane label="AIGC交付审核" name="aigc">
              <KhlTaskDeliveryAuditContent ref="aigcContent" />
            </el-tab-pane>
          </el-tabs>
      </PageHeaderLayout>
    </div>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import PrivatePersonnelListContent from "./components/PrivatePersonnelListContent.vue";
import KhlTaskDeliveryAuditContent from "./components/KhlTaskDeliveryAuditContent.vue";
export default {
  components: {
    PageHeaderLayout,
    PrivatePersonnelListContent,
    KhlTaskDeliveryAuditContent,
  },
  data() {
    return {
      activeTab: 'task'
    }
  },
  methods: {
    handleTabClick(tab) {
      this.$nextTick(() => {
        if (tab.name === 'task' && this.$refs.taskContent) {
          this.$refs.taskContent.init();
        }
        if (tab.name === 'aigc' && this.$refs.aigcContent) {
          this.$refs.aigcContent.init();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.main-page-content {
  padding-bottom: 50px;
}
</style>
